/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { InsiderTradingPlans } from '../models/insider-trading-plans';
import { IssuerTradingPlansFilters } from '../models/issuer-trading-plans-filters';
import { SecurityTagsWithIndeterminable } from '../models/security-tags-with-indeterminable';
@Injectable({
  providedIn: 'root',
})
class IssuerTradingPlansService extends __BaseService {
  static readonly getIssuerTradingPlansPath = '/issuer/tradingPlans';
  static readonly updateSecurityBreakdownTagsPath = '/update/securityBreakdownTags';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param filter undefined
   * @return returns a issuer trading plans
   */
  getIssuerTradingPlansResponse(filter: IssuerTradingPlansFilters): __Observable<__StrictHttpResponse<Array<InsiderTradingPlans>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = filter;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/issuer/tradingPlans`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<InsiderTradingPlans>>;
      })
    );
  }
  /**
   * @param filter undefined
   * @return returns a issuer trading plans
   */
  getIssuerTradingPlans(filter: IssuerTradingPlansFilters): __Observable<Array<InsiderTradingPlans>> {
    return this.getIssuerTradingPlansResponse(filter).pipe(
      __map(_r => _r.body as Array<InsiderTradingPlans>)
    );
  }

  /**
   * @param securityBreakdownTagsFilter undefined
   * @return it will be return boolean that whether tags was updated or not.
   */
  updateSecurityBreakdownTagsResponse(securityBreakdownTagsFilter: SecurityTagsWithIndeterminable): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = securityBreakdownTagsFilter;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/update/securityBreakdownTags`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param securityBreakdownTagsFilter undefined
   * @return it will be return boolean that whether tags was updated or not.
   */
  updateSecurityBreakdownTags(securityBreakdownTagsFilter: SecurityTagsWithIndeterminable): __Observable<boolean> {
    return this.updateSecurityBreakdownTagsResponse(securityBreakdownTagsFilter).pipe(
      __map(_r => _r.body as boolean)
    );
  }
}

module IssuerTradingPlansService {
}

export { IssuerTradingPlansService }
